/**
 * Lion Card Collections Grid — V2 (test copy, based on v1.0.0)
 * Adds tap feedback on touch devices (hover equivalent).
 * Re-inits on Shopify theme editor section reload.
 * Scoped to .lioncard-collections-v2 / .lc2-card so it never touches the
 * live section's elements, even when both are on the page at once.
 */
(function () {
  'use strict';

  if (typeof document === 'undefined') return;

  function initSection(section) {
    if (!section || section.dataset.lcInit === 'true') return;
    section.dataset.lcInit = 'true';

    var cards = section.querySelectorAll('.lc2-card');
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.addEventListener('touchstart', function () {
        card.classList.add('is-pressed');
      }, { passive: true });

      card.addEventListener('touchend', function () {
        setTimeout(function () { card.classList.remove('is-pressed'); }, 200);
      }, { passive: true });

      card.addEventListener('touchcancel', function () {
        card.classList.remove('is-pressed');
      }, { passive: true });
    });
  }

  function initAll() {
    document.querySelectorAll('.lioncard-collections-v2').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.lioncard-collections-v2');
      if (section) initSection(section);
    });
  }
})();